export const SET_SELECTED_COL = "SET_SELECTED_COL";
export const SET_SELECTED_ROW = "SET_SELECTED_ROW";
